import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const usePrefectures = (shouldFetch = true) => {
  const client = useGyymClient()
  return useGyymSWR(shouldFetch ? client.user.prefectures.list : null, {
    revalidateOnFocus: false,
  })
}
